import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { Customer } from '../../types/types';

interface AppState {
  customers: Customer[];
}

// Define the initial state using that type
const initialState: AppState = {
  customers: [],
};
export const ProductSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setAllCustomers: (state, action: PayloadAction<Customer[]>) => {
      state.customers = action.payload;
    },
  },
});

export const { setAllCustomers } = ProductSlice.actions;

export default ProductSlice.reducer;
